import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class VerifyServerCertificateService {

  constructor() { }



 verifyServerCertificate(serverCertificate: string): boolean {
  
  // Server's SSL certificate or public key stored in your application
  // const storedCertificate = `
  // -----BEGIN PUBLIC KEY-----
  // MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAtG0WjTyGwJLRUSCbRN55
  // pAi11/wk+QKZlET+VaNXed9YuV3lBWPUxaJOTW0uML/7TywmGXne0L7CBwbUBABy
  // lJ2jeFVAakNDaU43uAJf2yEQiT0BieE9pG6P86vMQyws4eZesf+ooKbrv5+Qf+t+
  // oOl1Tx06fk37eKBKxUew6Rm9t8FSE2n3Di93W2D2/DlPeMEEZlJNy5i//pUVfU39
  // wl98lL4XKmZ22PiSfJqT4S8s+DEmvJ/aYAmqrnwRfAgmuPpSuBq72w2iTudzDahu
  // UUuk5UmAgBhxq9LqryQ+ijpJvD+rttVhI/VtyH0aaPWvVRqdow+0D6kPVQx7w18s
  // AwIDAQAB
  // -----END PUBLIC KEY-----
  // `;
  const storedCertificate='../../../certificate/certificate_publickey.pem'

  // Hash the server's SSL certificate or public key
  const hashedServerCertificate = CryptoJS.SHA256(serverCertificate).toString();

  // Hash the stored certificate or public key
  const hashedStoredCertificate = CryptoJS.SHA256(storedCertificate).toString();

  // Compare the hashed values
  return hashedServerCertificate === hashedStoredCertificate;
}


  
}
